module.exports = "/assets/b7d0fb4e7abce409dc9c38464a5199b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/7T.png
// module id = 2252
// module chunks = 0